/**
 * Shorthand function to return full name from firstName and lastName input
 * @param input - object with firstName and lastName
 * @param reverse - if true, lastName will be first
 * @returns The full name
 */
export const getFullName = (input: { firstName?: string; lastName?: string }, reverse?: boolean) =>
	(reverse ? [input.lastName, input.firstName] : [input.firstName, input.lastName]).filter(Boolean).join(' ');

/**
 * Shorthand function to return name acronym
 * @param input - object with firstName and lastName
 * @returns The acronym (first letter of each name)
 */
export const getAcronym = <I extends Partial<NameBaseType>>(input: I) =>
	getFullName(input)
		.split(' ')
		.map((ch) => ch.charAt(0))
		.join('');

type NameBaseType = { firstName: string; lastName: string };
